import { useEffect, FC } from 'react';
import { CrawlerPageView } from './CrawlerPageView';
import { useListStore } from './hooks';

export const CrawlerPage: FC = () => {
  const { fetchCrawlers } = useListStore();

  useEffect(() => {
    void fetchCrawlers();
  }, [fetchCrawlers]);

  return <CrawlerPageView />;
};
